import {ButtonVariant} from '../../Buttons/Button/Button';

enum ContentfulCtaButtonVariant {
  CALL_TO_ACTION = 'Yellow',
  PRIMARY = 'Blue',
}

const getCtaButtonVariant = (userFriendlyVariantName: string): ButtonVariant => {
  switch (userFriendlyVariantName) {
    case ContentfulCtaButtonVariant.PRIMARY:
      return ButtonVariant.PRIMARY;
    default:
      return ButtonVariant.CALL_TO_ACTION;
  }
};

export default getCtaButtonVariant;
